import { ReactNode } from 'react';
import { PasswordValidity } from '../../helpers/passwordValidity';
import styles from './passwordValidity.module.css';

interface PasswordValidityHintProps {
  passwordValid: PasswordValidity;
}
interface RequirementProps {
  requirement: boolean;
  text: string;
  children?: ReactNode;
}

const Requirement: React.FC<RequirementProps> = ({
  requirement,
  text,
  children,
}: RequirementProps) => {
  return (
    <li className={requirement ? styles.valid : undefined}>
      <span>{text}</span>
      <span
        className={styles.requirement}
        aria-label={requirement ? 'Ja' : 'Nee'}
      />
      {children}
    </li>
  );
};

const PasswordValidityHint: React.FC<PasswordValidityHintProps> = ({
  passwordValid,
}: PasswordValidityHintProps) => {
  const { details } = passwordValid;
  return (
    <div className={styles.guidelines}>
      <h3>Houd je account veilig: kies een sterk wachtwoord</h3>
      <ul>
        <Requirement requirement={details.length} text="8 tekens of langer" />
        <Requirement
          requirement={details.characters}
          text="Bevat minstens 3 van de 4:"
        >
          <ul>
            <Requirement
              requirement={details.lowercase}
              text="Kleine letters (a-z)"
            />
            <Requirement
              requirement={details.uppercase}
              text="Hoofdletters (A-Z)"
            />
            <Requirement requirement={details.numbers} text="Cijfers (0-9)" />
            <Requirement
              requirement={details.specialChar}
              text="Speciale tekens (zoals !@#)"
            />
          </ul>
        </Requirement>
      </ul>
    </div>
  );
};

export default PasswordValidityHint;
